import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: (i = 0) => ({ opacity: 1, y: 0, transition: { duration: 0.8, ease: EASE, delay: i * 0.08 } }),
};

// CSS-driven scroll reveal — reliable, ends visible via fill-forwards.
export const Reveal = ({ children, className = "", delay = 0 }) => (
  <div className={`anim-up ${className}`} style={{ animationDelay: `${delay}s` }}>
    {children}
  </div>
);

// Line reveal for hero headlines — CSS keyframe, staggered via animationDelay.
export const MaskLine = ({ children, delay = 0 }) => (
  <span className="block leading-[1.12] anim-line" style={{ animationDelay: `${delay + 0.1}s` }}>
    {children}
  </span>
);

export { motion };
